import type { DeepPartial } from '@luna/utils-ts';

import type { ProductSettings } from '../../types/ProductSettings';

export const productSettingsSKFeatureConfig: DeepPartial<ProductSettings> = {
    showAccountInfo: true,
};
